import React from 'react';
import { Box } from 'grommet';
import Image from 'next/image';
import mathLogo from 'public/images/common/logo_RedBG.png';
import mathLogoWhite from 'public/images/common/white-logo.png';
import mathLogoBlack from 'public/images/common/US_@home_Logo_Stacked_ForWhiteBGRD.png';
import homer from 'public/images/common/Homer.png';
import styled from 'styled-components';

export const LogoHolder = styled(Box)`
	width: auto;
	display: flex;
	background-color: transparent;
	border: none;
	margin-left: 15px;
	align-items: center;
`;
export const ImageHolder = styled.span`
	margin-right: 10px;
`;

const Logo = ({
	withIcon,
	reverse,
}: {
	withIcon: boolean;
	reverse: boolean;
}) => (
	<LogoHolder>
		{withIcon && (
			<ImageHolder>
				<Image
					src={homer}
					width="40px"
					height="40px"
					alt="homer"
					style={{ marginRight: '10px' }}
				/>
			</ImageHolder>
		)}
		<Image
			src={reverse ? mathLogoWhite : mathLogo}
			width="130px"
			height="35px"
			layout="fixed"
			alt="hero"
		/>
	</LogoHolder>
);

const LogoBlack = () => (
	<LogoHolder>
		<Image src={mathLogoBlack} alt="hero" objectFit="contain" />
	</LogoHolder>
);

export default Logo;
export { LogoBlack };

